import { render, staticRenderFns } from "./TitlePage.vue?vue&type=template&id=a0c54004&scoped=true&"
import script from "./TitlePage.vue?vue&type=script&lang=js&"
export * from "./TitlePage.vue?vue&type=script&lang=js&"
import style0 from "./TitlePage.vue?vue&type=style&index=0&id=a0c54004&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c54004",
  null
  
)

export default component.exports